// Google SDK 初始化工具 - 用于 Shopify 项目
import Cookies from 'https://cdn.jsdelivr.net/npm/universal-cookie@8.0.1/+esm'

(function () {
    'use strict';

    const googleWindow = window;
    let sid = "";
    const cookies = new Cookies(null, { path: '/' })
    const COOKIE_KEY = 'momcozy-token'

    function isDevEnv() {
        const params = new URLSearchParams(location.search)
        const isDev = params.get('__dev__') === 'true' || sessionStorage.getItem('__dev__') === 'true'
        if (isDev && !sessionStorage.getItem('__dev__')) {
            sessionStorage.setItem('__dev__', 'true')
        }
        return isDev
    }

    function getApiUrl() {
        return isDevEnv() ? 'https://station-dev.luteshop.com' : 'https://account.momcozy.com'
    }

    const baseUrl = getApiUrl()


    // 获取 Google SDK
    function getGoogleSdk() {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://accounts.google.com/gsi/client";
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    // 解析查询字符串
    function getQueryString(result, name) {
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
        const r = result.substring(1).match(reg);
        if (r != null) return unescape(r[2]);
        return "";
    }

    // 第三方登录初始化接口
    async function thirdloginInit(params) {
        const endpoint = `${baseUrl}/api/station/user/login/init`;
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        });

        const result = await response.json();
        return result;
    }

    // 第三方登录系统接口
    async function thirdLoginSystem(type, params, config = {}) {
        const endpoint = `${baseUrl}/api/station/user/oauth/login/${type}`;
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...config.headers
            },
            body: JSON.stringify(params)
        });
        const result = await response.json();
        return result;
    }

    // 第三方社交登录API
    async function thirdSocialLogin(params) {
        const endpoint = `${baseUrl}/api/station/user/social/login`;
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        });

        const result = await response.json();
        return result;
    }

    function assemblyLogin(token, sid) {
        cookies.set(COOKIE_KEY, token, { domain: '.momcozy.com', maxAge: 7 * 24 * 60 * 60 })
        // report数据 todo
        // todo: 用户协议是干嘛
    }

    // 第三方登录状态
    const thirdLoginStatus = ({ result, sid, platform }) => {
        switch (result.status) {
            case 2: //邮箱不存在,需要绑定邮箱
                console.log('邮箱不存在，现在手机号一定会有邮箱了，不存在这种情况了')
                break
            case 3: //邮箱已存在,需要验证密码
                document.querySelector('third-verify-password-dialog')?.open({
                    sid,
                    platform,
                    email: result.email,
                })
                break
            case 10: //授权成功
                assemblyLogin(result.token, sid)
                break
            case 11: //会话过期,需要重新开始
                console.log('会话过期')
        }
    }

    // 状态成功
    function statusSuccess({
        accessToken = "",
        sid = "",
        clientId = "",
        scope = "",
    }) {
        thirdSocialLogin({
            sid,
            subjectToken: accessToken,
            clientId,
            grantType: "urn:ietf:params:oauth:grant-type:token-exchange",
            subjectIssuer: "GOOGLE_ID_TOKEN",
            subjectTokenType: "urn:ietf:params:oauth:token-type:id_token",
            scopes: scope,
        }).then((res) => {
            thirdLoginStatus({ result: res.result, sid, platform: "google" })
        });
    }

    async function initGooleAccounts() {
        if (!googleWindow.google) return;
        thirdloginInit({
            platForm: "SHOPIFY",
            countryCode: "US",
            countryName: "United States",
            redirectUrl: location.href,
            registerSource: "",
        }).then(async (res) => {
            sid = res.result?.sid || res.sid || "";
            const { result } = await thirdLoginSystem("google", { sid });
            const clientId = getQueryString(result, "client_id");
            const scope = getQueryString(result, "scope");
            googleWindow.google.accounts.id.initialize({
                client_id: clientId,
                ux_mode: "popup",
                auto_select: false,
                itp_support: true,
                callback: (response) => {
                    statusSuccess({
                        accessToken: response.credential,
                        sid,
                        clientId: clientId,
                        scope: scope,
                    });
                },
            });
            // 弹框
            googleWindow.google.accounts.id.prompt();
        })
    }

    async function initGoogleLoginPopup() {
        await getGoogleSdk();
        await initGooleAccounts();
    }

    // 初始化 Google 登录
    async function initGoogleSDK() {
        const token = cookies.get(COOKIE_KEY);
        if (!token) {
            initGoogleLoginPopup()
        } else {
            // 这里还需要判断一下这个账号是否被删了
            fetch(`${baseUrl}/api/station/user/getUserInfo`, {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        return response.json().then((data) => {
                            return Promise.reject({
                                message: `${response.status} ${response.statusText}`,
                                data: data,
                            });
                        });
                    }
                })
                .then((res) => {
                    if (+res.code !== 200) {
                        cookies.remove(COOKIE_KEY);
                        cookies.remove(COOKIE_KEY, { domain: '.momcozy.com' });
                        initGoogleLoginPopup()
                    }
                })
                .finally(() => { });
        }
    }

    // 页面加载时自动执行
    document.addEventListener('DOMContentLoaded', initGoogleSDK);

    document.addEventListener('LUTE:AUTH:THIRD-LOGIN:SUCCESS', (e) => {
        assemblyLogin(e.detail.token, e.detail.sid)
    })
})();